import { type ReactNode } from 'react';
import { TabsList, TabsRoot } from '@/ui_v3/components/tabs/tabsRoot';
import { TabsTrigger, type TabsTriggerProps } from '@/ui_v3/components/tabs/TabsTrigger';
import { cn } from '@/utils';
export const Tabs = <T extends string,>(props: TabProps<T>) => {
  const {
    isFull,
    size,
    options,
    value,
    onValueChange,
    className,
    tabTriggerProps
  } = props;
  return <TabsRoot value={value} onValueChange={v => onValueChange(v as T)} data-sentry-element="TabsRoot" data-sentry-component="Tabs" data-sentry-source-file="Tabs.tsx">
      <TabsList className={cn('w-full', className)} data-sentry-element="TabsList" data-sentry-source-file="Tabs.tsx">
        {options.map(tab => <TabsTrigger className={isFull ? cn('flex-1', tabTriggerProps?.className) : tabTriggerProps?.className} size={size} value={tab.value} key={tab.value}>
            {tab.label}
          </TabsTrigger>)}
      </TabsList>
    </TabsRoot>;
};
export type TabProps<T extends string = string> = {
  isFull: boolean;
  size: TabsTriggerProps['size'];
  value: T;
  onValueChange: (value: T) => void;
  options: {
    value: T;
    label: ReactNode;
  }[];
  className?: string;
  tabTriggerProps?: Pick<TabsTriggerProps, 'className'>;
};